




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserFriendlyError } from '@/services/AutoApprovalErrorHandler';

@Component({
  name: 'AutoApprovalErrorMessage'
})
export default class AutoApprovalErrorMessage extends Vue {
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  @Prop({ type: Object, required: true })
  errorInfo!: UserFriendlyError;

  @Prop({ type: String, default: '' })
  technicalDetails!: string;

  @Prop({ type: Boolean, default: false })
  showTechnicalDetails!: boolean;

  @Prop({ type: Boolean, default: false })
  retrying!: boolean;

  private showDetails = false;

  get errorDescription(): string {
    return this.errorInfo.message;
  }

  private onClose() {
    this.showDetails = false;
    this.$emit('close');
  }

  private onRetry() {
    this.$emit('retry');
  }
}
